// Auto-generated from translation.csv; do not edit manually
export const viVN = {
  "accountGuide": {
    "content": "Mở bất kỳ một trò chơi nào thuộc Touka, vào giao diện cài đặt trong game, liên kết email của bạn để nhận ưu đãi mua hàng giảm giá!",
    "title": "Làm thế nào để tạo tài khoản?"
  },
  "bottomNav": {
    "home": "Trang chủ",
    "myOrders": "Đơn hàng của tôi"
  },
  "common": {
    "loading": "Đang tải...",
    "noData": "Không có dữ liệu",
    "server": "Máy chủ"
  },
  "footer": {
    "language": "Tiếng Trung (Giản thể)",
    "privacyPolicy": "Chính sách bảo mật",
    "refundPolicy": "Chính sách hoàn tiền",
    "termsOfService": "Điều khoản dịch vụ",
    "userSupport": "Hỗ trợ người dùng",
    "downloadNow": "Tải xuống ngay!"
  },
  "header": {
    "characterName": "Tên nhân vật",
    "gameServer": "Khu vực nhóm trò chơi",
    "selectGameServer": "Chọn khu vực máy chủ trò chơi",
    "greeting": "Xin chào",
    "loginPrompt": "Vui lòng nhấn đăng nhập",
    "switchServer": "Chuyển đổi",
    "title": "Trung tâm nạp game",
    "logout": "Đăng xuất"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Ối! Croco"
  },
  "history": {
    "backToGameZone": "Quay lại cửa hàng game",
    "allGames": "Tất cả game",
    "empty": "Chưa có đơn hàng",
    "filter": {
      "all": "Tất cả",
      "closed": "Đã đóng",
      "completed": "Đã hoàn thành",
      "inProgress": "Đang tiến hành",
      "pendingDelivery": "Chờ gửi hàng"
    },
    "orderTime": "Thời gian đặt hàng:",
    "pendingAutoCancelPrefix": "Đơn hàng sẽ tự động hủy sau",
    "pendingAutoCancelSuffix": "nữa",
    "cancelOrder": "Hủy đơn hàng",
    "payOrder": "Thanh toán",
    "cancelOrderConfirmTitle": "Xác nhận hủy đơn hàng?",
    "cancelOrderConfirmPrimary": "Xác nhận hủy",
    "cancelOrderDismiss": "Để sau",
    "status": {
      "cancelled": "Đã hủy",
      "completed": "Giao dịch hoàn thành",
      "paid": "Đã thanh toán",
      "pending": "Chờ thanh toán",
      "shipped": "Đã gửi hàng"
    }
  },
  "home": {
    "selectGame": "Chọn trò chơi bạn muốn nạp tiền",
    "selectGameMobileTitle": "Chọn game nạp tiền",
    "selectGameParts": {
      "prefix": "Chọn trò chơi bạn muốn ",
      "keyword": "nạp tiền",
      "suffix": ""
    },
    "noRoleAccount": "Bạn chưa có nhân vật trong game này. Vui lòng tạo nhân vật trong game trước khi mua.",
    "noRoleRefreshPrefix": "Đã tạo tài khoản? Nhấn ",
    "noRoleRefreshAction": "Làm mới",
    "noRoleRefreshing": "Đang làm mới…",
    "noRoleRefreshNotFound": "Không tìm thấy thông tin nhân vật",
    "noRoleRefreshFailed": "Làm mới thất bại. Vui lòng thử lại sau."
  },
  "login": {
    "agreeTerms": {
      "and": "và",
      "prefix": "Tôi đã đọc và đồng ý",
      "privacy": "Chính sách bảo mật",
      "terms": "Điều khoản dịch vụ"
    },
    "cancel": "Hủy",
    "bindGameGuide": "Lưu ý liên kết game",
    "bindGameGuideContent": "Mở bất kỳ game Touka nào,\nvào mục Cài đặt trong game,\nliên kết email của bạn\nđể được hưởng ưu đãi đặc biệt tại cửa hàng!",
    "captchaPlaceholder": "Mã xác nhận",
    "invalidCaptcha": "Vui lòng nhập mã xác nhận 4 chữ số",
    "email": "Email",
    "emailNotBound": "Không tìm thấy tài khoản. Vui lòng nhập email đã liên kết với tài khoản trong game~",
    "emailPlaceholder": "Vui lòng nhập email của bạn",
    "keepLogin": "Giữ trạng thái đăng nhập trong 15 ngày",
    "loading": "Đang đăng nhập...",
    "loginToStore": "Đăng nhập Touka Store",
    "noAccount": "Chưa có tài khoản?",
    "password": "Mật khẩu",
    "passwordPlaceholder": "Vui lòng nhập mật khẩu",
    "submit": "Đăng nhập",
    "title": "Đăng nhập",
    "invalidEmail": "Vui lòng nhập địa chỉ email hợp lệ"
  },
  "logout": {
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "dontRemind": "Lần sau không nhắc lại",
    "messageLine1": "Sau khi đăng xuất, trạng thái đăng nhập trên tất cả thiết bị đã dùng trong 30 ngày gần đây",
    "messageLine2": "sẽ hết hiệu lực.",
    "title": "Lưu ý"
  },
  "menu": {
    "contactSupport": "Liên hệ dịch vụ khách hàng",
    "gameList": "Danh sách trò chơi",
    "myOrders": "Đơn hàng của tôi"
  },
  "paymentSuccess": {
    "account": "Tài khoản:",
    "celebrationTitle": "Mua thành công",
    "confirm": "Xác nhận",
    "getPaymentInfoFailed": "Lấy thông tin thanh toán thất bại",
    "loading": "Đang tải...",
    "orderDate": "Ngày đơn hàng:",
    "orderId": "Số đơn hàng:",
    "paymentMethod": "Phương thức thanh toán:",
    "paypal": "PayPal",
    "price": "Giá:",
    "purchaseContent": "Nội dung mua:",
    "quantity": "Số lượng mua:",
    "serverAndCharacter": "Khu vực/nhân vật:",
    "title": "Cảm ơn đã mua hàng",
    "total": "Tổng cộng:",
    "unionPay": "Ngân hàng UnionPay",
    "amountPaid": "Số tiền thanh toán:",
    "closeModal": "Đóng"
  },
  "productModal": {
    "confirm": "Xác nhận",
    "purchaseDetails": "Chi tiết mua hàng",
    "quantity": "Số lượng:",
    "total": "Tổng cộng:",
    "unitPrice": "Đơn giá:"
  },
  "products": {
    "giftPacks": "Gói quà",
    "diamond": "Kim cương",
    "products": "Sản phẩm",
    "vouchers": "Phiếu giảm giá",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Mua sắm tại TOUKA Store và nhận thêm 10% phần thưởng!",
    "superValue": "Siêu hời",
    "limitShort": "Giới hạn",
    "remainingShort": "Còn lại",
    "giftPackLimitType": {
      "lifetime": "Trọn đời",
      "weekly": "Theo tuần",
      "monthly": "Theo tháng"
    },
    "howToUseVouchers": "Cách sử dụng phiếu giảm giá?",
    "voucherGuide": {
      "title": "Cách sử dụng phiếu giảm giá?",
      "step1": "1. Vui lòng kiểm tra hộp thư trong game để nhận phiếu giảm giá bạn đã mua.",
      "step2": "2. Bạn có thể xem số lượng phiếu giảm giá của mình ở phía trên tab cửa hàng trong game. Khi bạn có đủ phiếu giảm giá để mua gói quà, hệ thống sẽ ưu tiên dùng phiếu giảm giá để thanh toán.",
      "backToProducts": "Quay lại danh sách sản phẩm"
    },
    "luxuryVouchers": "Phiếu giảm giá cao cấp"
  },
  "purchaseConfirm": {
    "card": "Thẻ tín dụng/thẻ ghi nợ",
    "confirm": "Xác nhận",
    "dontAskAgain": "Không hỏi lại trong 30 ngày",
    "gameServer": "Máy chủ game",
    "paymentMethods": "Phương thức thanh toán được hỗ trợ",
    "paypal": "PayPal",
    "title": "Bạn có chắc chắn muốn mua hàng bằng tài khoản này không?",
    "unionPay": "Thẻ UnionPay"
  },
  "serverSelect": {
    "characterLabel": "Tên nhân vật",
    "characterPlaceholder": "Vui lòng chọn nhân vật",
    "confirm": "Xác nhận",
    "noResults": "Chưa có kết quả",
    "serverPlaceholder": "Vui lòng nhập tên khu vực máy chủ để tìm kiếm",
    "title": "Chọn máy chủ game"
  },
  "support": {
    "cancel": "Hủy",
    "copied": "Đã sao chép",
    "copy": "Sao chép một lần",
    "description": "Vui lòng gửi thông tin chi tiết của bạn đến email hỗ trợ chính thức.",
    "title": "Hỗ trợ khách hàng"
  },
  "verification": {
    "back": "Quay lại",
    "enterCode": "Vui lòng nhập mã xác nhận để tiếp tục",
    "incorrectCode": "Mã xác nhận không chính xác",
    "invalidCode": "Vui lòng nhập mã xác nhận 6 ký tự",
    "noCode": "Không nhận được mã xác nhận?",
    "sentTo": "Mã xác nhận đã được gửi đến",
    "submit": "Gửi",
    "submitting": "Đang gửi..."
  }
} as const;
